"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dewPointTemperatureConversions = dewPointTemperatureConversions;
const calculations_1 = require("@munters/calculations");
function dewPointTemperatureConversions(fromAmount, to, conversionParameters) {
    const pressureAmount = conversionParameters.pressure;
    const temperatureAmount = conversionParameters.temperature;
    switch (to) {
        case "RelativeHumidity": {
            return calculations_1.Physics.RP1485.AmountConversions.dewPointTemperatureToRelativeHumidity(pressureAmount, temperatureAmount, fromAmount);
        }
        case "HumidityRatio": {
            return calculations_1.Physics.RP1485.AmountConversions.dewPointTemperatureToHumidityRatio(pressureAmount, fromAmount);
        }
        case "SpecificEnthalpy": {
            return calculations_1.Physics.RP1485.AmountConversions.dewPointTemperatureToSpecificEnthalpy(pressureAmount, temperatureAmount, fromAmount);
        }
        case "WetTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.dewPointTemperatureToWetTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=dew-point-temperature-conversions.js.map